// extracted by mini-css-extract-plugin
export var label = "_gg-0";
export var treatmentCard = "_gg-1";